import { render } from "./ProgramBreakdownChart.vue?vue&type=template&id=a3e91724"
import script from "./ProgramBreakdownChart.vue?vue&type=script&lang=js"
export * from "./ProgramBreakdownChart.vue?vue&type=script&lang=js"
script.render = render

export default script